export interface ICoachDrawerPhone {
    phoneTypeId: number;
    number: string;
}

export interface ICoachDrawerContact {
    fullName: string;
    email: string;
    phoneNumbers: ICoachDrawerPhone[];
}

export interface ICoachDrawerCenter {
    id: number;
    alias: string;
    isUtilizing3gKidneyForLife: boolean;
}

export interface ICoachDrawerLogEntry {
    id: number;
    micrositeRecipientId: number;
    logDateTime: string;
    updatedDateTime: string | null;
    actionType: number | null;
    content: string;
    isPinned: boolean;
}

export interface ICoachDrawerChampion {
    name: string;
    email: string;
    phone: string;
}

export interface ICoachDrawerDetail {
    id: number;
    shortCode: string;
    editKey: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    secondaryEmail: string | null;
    phonePrimary: string | null;
    phoneSecondary: string | null;
    addressLine1: string;
    addressLine2: string | null;
    city: string;
    state: string;
    postalCode: string;
    birthdate: string | null;
    age: number;
    gender: number;
    languagePreference: string | null;
    currentStatusDescription: string;
    center: ICoachDrawerCenter | null;
    coordinatorContact: ICoachDrawerContact | null;
    secondaryCoordinatorContact: ICoachDrawerContact | null;
    coachFullName: string | null;
    coachStatus: number | null;
    coachStatusDescription: string | null;
    nextFollowupDate: string | null;
    mostRecentCoachContactDateTime: string | null;
    isCoachingDesired: boolean;
    isCoachAllowedToEdit: boolean;
    transplantDate: string | null;
    mostRecentCoachNotificationEventDate: string | null;
    businessCardsRequestDate: string | null;
    coachLogEntries: ICoachDrawerLogEntry[];
    champion: ICoachDrawerChampion | null;
}
